<template>
  <v-card flat class="mt-1 grey lighten-4">
    <!-- Search reulsts filter -->
    <v-slide-y-transition>
      <v-card-title v-if="showGridFilter">
        <v-layout row wrap>
          <v-flex sm6>
            <v-text-field append-icon="filter_list" :label="messages.label.PROCESSING_RECORDS_FILTER" single-line
              hide-details clearable v-model="search" @input="value => filterSearchResult(value)">
            </v-text-field>
          </v-flex>
          <v-flex sm6 class="text-xs-right">
            <span>
              <v-icon color="accent darken-2" class="pr-2" small>info</v-icon>
              <span v-html="messages.info.STATE_INFO"></span>
            </span>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-slide-y-transition>
    <!-- Search Results -->
    <v-card-text class="py-1">
      <v-data-table :headers="headers" :items="filteredSearchResult" :pagination.sync="pagination"
        :total-items="totalItems" :loading="assetsLoading" :rows-per-page-items="rowsPerPagesArray">
        <!-- Items -->
        <template slot="items" slot-scope="props">
          <tr @click="toggleStateInfo($event, props)" class="pointer"
            :class="{ 'light-green lighten-3 black--text': isRecordOperatedNow(props.item) }">
            <td @click.stop="stopProp">
              <v-menu bottom right :disabled="assetsLoading">
                <v-btn icon slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="editXML(props.item)" v-if="isRecordEditable(props.item)">
                    <v-list-tile-title>{{ messages.label.EDIT_XML }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="viewXML(props.item)" v-else>
                    <v-list-tile-title>{{ messages.label.VIEW_XML }}</v-list-tile-title>
                  </v-list-tile>
                  <!-- <v-list-tile @click="cloneRecord(props.item)"
                                 v-if="isRecordClonable(props.item)">
                     <v-list-tile-title>{{messages.label.CLONE}}</v-list-tile-title>
                   </v-list-tile> -->
                  <v-list-tile @click="publishRecord(props.item)" v-if="isRecordPublishable(props.item)">
                    <v-list-tile-title>{{ messages.label.PUBLISH }}</v-list-tile-title>
                  </v-list-tile>
                  <!-- <v-list-tile @click="assetOffers(props.item)">
                     <v-list-tile-title>{{messages.label.OFFERS}}</v-list-tile-title>
                   </v-list-tile> -->
                  <v-list-tile @click="deleteRecordConfirmation(props.item)" v-if="canDeleteRecord(props.item)">
                    <v-list-tile-title>{{ messages.label.DELETE }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
            <td class="text-xs-left">{{ props.item.state }}</td>
            <td class="text-xs-left">{{ props.item.format }}</td>
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left">{{ props.item.paid }}</td>
            <td class="text-xs-left">{{ props.item.originationId }}</td>
            <td class="text-xs-left">{{ props.item.provider }}</td>
            <td class="text-xs-left">{{ props.item.manifestId }}</td>
            <td class="text-xs-left">{{ props.item.metadataVersion }}</td>
            <td class="text-xs-left">{{ props.item._updated }}</td>
            <td class="text-xs-left">{{ props.item._added }}</td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            <span v-if="!initiatedSearch">
              {{ messages.info.SELECT_SEARCH_CRITERIA }}
            </span>
            <span v-else>
              {{ messages.info.NO_SEARCH_RESULTS }}
            </span>
          </v-alert>
        </template>
        <!-- No Results -->
        <template slot="no-results">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_FILTER_RESULTS }}
          </v-alert>
        </template>
        <!-- Expand -->
        <template slot="expand" slot-scope="props">
          <v-card flat color="info">
            <v-card-text>
              <span class="body-2">{{ messages.label.STATE_INFORMATION }}:</span>
              {{ props.item.stateInfo }}
            </v-card-text>
          </v-card>
        </template>
        <!-- Page Text -->
        <template slot="pageText" slot-scope="props">
          {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
        </template>
      </v-data-table>
      <v-snackbar :timeout="snackbar.timeout" :top="true" color="light-green black--text" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
      </v-snackbar>
    </v-card-text>
    <!-- Dialogs -->
    <ProcessingRecordMetadataEdit />
    <CloneRecord />
    <PublishRecord />
    <AssetOffers />
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="headline font-weight-light">
          {{ messages.label.DELETE_PROCESSING_RECORD }}
        </v-card-title>
        <v-card-text>
          {{ messages.info.DELETE_PROCESSING_RECORD }} <b>{{ selectedAssetToDelete.title }} ?</b>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 white--text" @click="cancelDelete">
            {{ messages.label.CANCEL }}
          </v-btn>
          <v-btn color="primary" :loading="deletingRecord" :disabled="deletingRecord" @click="deleteRecord">
            {{ messages.label.DELETE }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import PreIngestService from "@/PreIngest/PreIngestService"
import * as preIngestDataService from "@/PreIngest/PreIngestDataService"
import AppService from "@/AppService"
import messages from "@/PreIngest/messages.json"
import { VOD_SYCN_PREINGEST_DATA_SERVICE_URL } from "@/store/constants/getter-types"
import ProcessingRecordMetadataEdit from "@/PreIngest/ProcessingRecords/ProcessingRecordMetadataEdit"
import CloneRecord from "@/PreIngest/ProcessingRecords/CloneRecord"
import PublishRecord from "@/PreIngest/ProcessingRecords/PublishRecord"
import AssetOffers from "@/PreIngest/ProcessingRecords/AssetOffers"
import * as utils from "@/Shared/utils"

/**
 * initialData
 */
function initialData(instance) {
  return {
    search: "",
    assetsLoading: false,
    initiatedSearch: false,
    deleteDialog: false,
    deletingRecord: false,
    pagination: {
      sortBy: "",
      page: 1,
      rowsPerPage: 25,
      descending: false
    },
    snackbar: {
      show: false,
      message: "",
      timeout: 6000
    },
    totalItems: 0,
    rowsPerPagesArray: [25, 50, 75, 100],
    headers: instance.getTableHeaders(),
    searchResult: [],
    filteredSearchResult: [],
    selectedAsset: {},
    selectedAssetToClone: {},
    selectedAssetToPublish: {},
    selectedAssetForOffers: {},
    selectedAssetToDelete: {},
    searchObject: {}
  }
}

export default {
  name: "ProcessingRecordsSearchResult",
  components: {
    ProcessingRecordMetadataEdit,
    CloneRecord,
    PublishRecord,
    AssetOffers
  },
  data: function () {
    return initialData(this)
  },
  computed: {
    ...mapState([
      "mpxParentAccount"
    ]),
    ...mapGetters([
      VOD_SYCN_PREINGEST_DATA_SERVICE_URL
    ]),
    showGridFilter() {
      return this.searchResult.length > 0
    }
  },
  watch: {
    /**
     * Watch handler for pagination object
     */
    pagination: {
      handler(newVal, oldVal) {
        if (this.initiatedSearch && oldVal !== newVal) {
          this.searchProcessingRecords()
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * For filtering search result with text value
     */
    filterSearchResult(search) {
      if (search) {
        search = search.toString().toLowerCase()
        const displayedKeys = [
          "title",
          "paid",
          "provider",
          "state",
          "manifestId",
          "metadataVersion",
          "format",
          "originationId",
          "_updated",
          "_added"
        ]
        this.filteredSearchResult = this.searchResult.filter((obj) => {
          let filteredObj = this.$lodash.pick(obj, displayedKeys)
          return Object.keys(filteredObj).some(function (key) {
            if (filteredObj[key] !== null) {
              return filteredObj[key]
                .toString()
                .toLowerCase()
                .includes(search)
            }
          })
        })
      } else {
        this.filteredSearchResult = this.searchResult
      }
    },

    /**
     * Get pagination params
     */
    getPageParams(pagination) {
      let startRange
      let endRange
      if (pagination.page === 1) {
        startRange = 1
        endRange = pagination.rowsPerPage
      } else {
        startRange = (pagination.page - 1) * pagination.rowsPerPage + 1
        endRange = startRange + pagination.rowsPerPage - 1
      }
      return startRange + "-" + endRange
    },

    /**
     * getSortParams - Construct sorting param
     *
     * @param  {object} pagination pagination object
     * @return {string}            ex: '<filedName>|desc'
     */
    getSortParams(pagination) {
      let sortParams = ""
      sortParams =
        !this.$lodash.isNull(pagination.sortBy) &&
          !this.$lodash.isEmpty(pagination.sortBy)
          ? pagination.sortBy
          : "added|desc"
      if (pagination.descending) {
        sortParams += "|desc"
      }
      return sortParams
    },

    /**
     * searchProcessingRecords - search processing records
     *
     * @param  {object} reason contains any pre-condition for searching
     * (cloning, publishing etc)
     */
    searchProcessingRecords(reason) {
      let clonedRecordIds = []
      let publishedRecordIds = []
      if (!this.$lodash.isUndefined(reason)) {
        // Search is triggered due to cloning
        if (reason.clone) {
          clonedRecordIds = reason.clonedRecordIds
          this.searchObject.sort = "added|desc"
          this.pagination.descending = true
          this.pagination.sortBy = "added"
          this.pagination.page = 1
        } else if (reason.publish) {
          // Search is triggered due to publishing
          publishedRecordIds = reason.publishedRecordId
          this.searchObject.sort = "updated|desc"
          this.pagination.descending = true
          this.pagination.sortBy = "updated"
          this.pagination.page = 1
        }
      }
      this.searchObject.range = this.getPageParams(this.pagination)
      this.searchObject.sort = this.getSortParams(this.pagination)
      this.searchObject.count = true
      this.retrieveProcessingRecords().then((searchResult) => {
        if (clonedRecordIds.length > 0) {
          // Mark records so that they can be identified as cloned records
          this.searchResult = this.markRecords(searchResult, clonedRecordIds)
          this.snackbar.message = this.messages.info.CLONED_RECORDS
          this.snackbar.show = true
        } else if (publishedRecordIds.length > 0) {
          // Mark record so that they can be identified as published record
          this.searchResult = this.markRecords(searchResult, publishedRecordIds)
          this.snackbar.message = this.messages.info.PUBLISHED_RECORD
          this.snackbar.show = true
        } else {
          this.searchResult = searchResult
        }
      })
    },

    /**
     * retrieveProcessingRecords - Retrieve processing records from server
     *
     * @return {Promise}  search promise
     */
    retrieveProcessingRecords() {
      this.assetsLoading = true
      return preIngestDataService
        .retrieveProcessingRecords(this.searchObject,
          this.VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
        .then((response) => {
          if (!this.$lodash.isUndefined(response.data.entries)) {
            this.searchResult = response.data.entries
            this.convertDateTimeString()
            this.filterSearchResult(this.search)
            this.totalItems = response.data.totalResults
          } else {
            this.searchResult = []
          }
          this.assetsLoading = false
          this.initiatedSearch = true
          return this.searchResult
        }).catch((error) => {
          this.searchResult = []
          this.filteredSearchResult = []
          this.totalItems = 0
          this.assetsLoading = false
          this.initiatedSearch = true
          return Promise.reject(error)
        })
    },

    /**
     * converting added and updated unix time stamp to local date time string
     */
    convertDateTimeString() {
      let recordObject
      for (var item in this.searchResult) {
        recordObject = this.searchResult[item]
        recordObject._updated = !this.$lodash.isNull(recordObject.updated)
          ? this.getLocalDateTime(recordObject.updated)
          : ""
        recordObject._added = !this.$lodash.isNull(recordObject.added)
          ? this.getLocalDateTime(recordObject.added)
          : ""
      }
    },

    /**
     * isRecordOperatedNow - Check if the reocrd is cloned or published in current session
     *
     * @param  {object} processingRecord
     * @return {boolean}
     */
    isRecordOperatedNow(processingRecord) {
      return processingRecord._operatedNow
    },

    /**
     * markRecords - Adds property '_operatedNow' to identify cloned records & published records
     *
     * @param  {object} searchResult
     * @param  {array} recordIds currently cloned or published record Ids
     * @return {object}  search results with operated records marked
     */
    markRecords(searchResult, recordIds) {
      // Mark records with '_operatedNow' property to highlight them in data grid
      let operatedRecordNumbers = this.$lodash.map(recordIds, (recordId) => {
        return this.$lodash.last(recordId.split("/"))
      })
      this.$lodash.forEach(searchResult, (processingRecord) => {
        let index = this.$lodash.findIndex(
          operatedRecordNumbers,
          (operatedRecordNumber) => {
            let recordNumber = this.$lodash.last(processingRecord.id.split("/"))
            return operatedRecordNumber === recordNumber
          }
        )
        if (index > -1) {
          processingRecord._operatedNow = true
        } else {
          processingRecord._operatedNow = false
        }
      })
      return searchResult
    },

    /**
     * getTableHeaders - Construct array of objects to show table headers
     *
     * @return {array}
     */
    getTableHeaders() {
      let headers = [
        {
          text: "",
          sortable: false
        },
        {
          text: messages.label.TH_STATE,
          align: "left",
          sortable: false,
          value: "state"
        },
        {
          text: messages.label.TH_FORMAT,
          align: "left",
          value: "state",
          sortable: false
        },
        {
          text: messages.label.TH_TITLE,
          align: "left",
          value: "title"
        },
        {
          text: messages.label.TH_PACKAGE_ID,
          align: "left",
          sortable: false,
          value: "paid"
        },
        {
          text: messages.label.TH_ORIGINATION_ID,
          align: "left",
          value: "paid",
          sortable: false
        },
        {
          text: messages.label.TH_PROVIDER,
          align: "left",
          sortable: false,
          value: "provider"
        },
        {
          text: messages.label.TH_MANIFEST_ID,
          align: "left",
          sortable: false,
          value: "manifestId"
        },
        {
          text: messages.label.TH_METADATA_VERSION,
          align: "left",
          value: "metadataVersion"
        },
        {
          text: messages.label.TH_LAST_UPDATED,
          align: "left",
          value: "updated"
        },
        {
          text: messages.label.TH_ADDED_DATE,
          align: "left",
          value: "added"
        }
      ]

      return headers
    },

    /**
     * getLocalDateTime - Retrieve local time
     *
     * @param  {Number} dateTime unix time stamp
     * @return {string}          date time in local
     */
    getLocalDateTime(dateTime) {
      return utils.getLocalDateTime(dateTime)
    },

    /**
     * editXML - Open XML Editor to start editing
     *
     * @param  {object} selectedAsset
     */
    editXML(selectedAsset) {
      let readOnly = false
      PreIngestService.$emit("event:showMetadataEdit", selectedAsset, readOnly)
      this.selectedAsset = selectedAsset
    },

    /**
     * viewXML - Open XML in readonly mode
     *
     * @param  {type} selectedAsset
     */
    viewXML(selectedAsset) {
      let readOnly = true
      PreIngestService.$emit("event:showMetadataEdit", selectedAsset, readOnly)
      this.selectedAsset = selectedAsset
    },

    /**
     * isRecordEditable - Identify if record can be edited
     *
     * @param  {object} processingRecord
     * @return {boolean}
     */
    isRecordEditable(processingRecord) {
      let editableStates = ["ERROR", "AUDIT"]
      let rtnVal = false

      if (this.$lodash.indexOf(editableStates, processingRecord.state) > -1) {
        rtnVal = true
      }
      return rtnVal
    },

    /**
     * isRecordEditable - Identify if record can be edited
     *
     * @param  {object} processingRecord
     * @return {boolean}
     */
    canDeleteRecord(processingRecord) {
      let deletableStates = ["ERROR", "AUDIT"]
      let rtnVal = false

      if (this.$lodash.indexOf(deletableStates, processingRecord.state) > -1) {
        rtnVal = true
      }
      return rtnVal
    },

    /**
     * isRecordPublishable - Identify if record can be published
     *
     * @param  {object} processingRecord
     * @return {boolean}
     */
    isRecordPublishable(processingRecord) {
      let rtnVal = false
      if (processingRecord.state === "AUDIT") {
        rtnVal = true
      }
      return rtnVal
    },

    /**
     * isRecordClonable - Identify if record can be published
     *
     * @param  {object} processingRecord
     * @return {boolean}
     */
    isRecordClonable(processingRecord) {
      let rtnVal = false
      if (processingRecord.state === "AUDIT") {
        rtnVal = true
      }
      return rtnVal
    },

    /**
     * toggleStateInfo - Show / Hide state information
     *
     * @param  {object} event
     * @param  {object} props
     */
    toggleStateInfo(event, props) {
      //  NOTE: Little hack to avoid togging state info on clicking menu button
      if (event.target.className !== "btn__content") {
        props.expanded = !props.expanded
      }
    },

    /**
     * cloneRecord - Show dialog to begin cloning
     *
     * @param  {object} selectedAsset
     */
    cloneRecord(selectedAsset) {
      PreIngestService.$emit("event:showCloneRecord", selectedAsset)
      this.selectedAssetToClone = selectedAsset
    },

    /**
     * publishRecord - Show dialog to begin publishing
     *
     * @param  {object} selectedAsset
     */
    publishRecord(selectedAsset) {
      PreIngestService.$emit("event:showPublishRecord", selectedAsset)
      this.selectedAssetToPublish = selectedAsset
    },

    /**
     * deleteRecord - Show confirmation to delete record
     *
     * @param  {object} selectedAsset
     */
    deleteRecordConfirmation(selectedAsset) {
      this.selectedAssetToDelete = selectedAsset
      this.deleteDialog = true
    },

    /**
     * Reset data and do not proceed with delete
     */
    cancelDelete() {
      this.selectedAssetToDelete = {}
      this.deleteDialog = false
    },

    /**
     * deleteRecord - Delete processing record
     * @return {Promise}  search promise
     */
    deleteRecord() {
      this.deletingRecord = true
      let recordId = this.selectedAssetToDelete.id.split("/").pop()
      return preIngestDataService
        .deleteProcessingRecord(recordId, VOD_SYCN_PREINGEST_DATA_SERVICE_URL)
        .then((response) => {
          let snackBar = {
            type: "success",
            msg: this.messages.info.DELETE_PROCOESSING_RECORD_SUCCESS
          }
          PreIngestService.$emit("event:showSnackBar", snackBar)
          PreIngestService.$emit("event:refreshSearchResult")
          return response
        })
        .catch((error) => {
          let snackBar = {
            type: "error",
            msg: this.messages.error.DELETE_PROCESSING_RECORD_FAILURE
          }
          PreIngestService.$emit("event:showSnackBar", snackBar)
          return Promise.reject(error)
        })
        .finally(() => {
          this.deletingRecord = false
          this.deleteDialog = false
        })
    },

    /**
     * assetOffers - Show dialog for displaying offers
     *
     * @param  {object} selectedAsset
     */
    assetOffers(selectedAsset) {
      PreIngestService.$emit("event:showAssetOfferings", selectedAsset)
      this.selectedAssetForOffers = selectedAsset
    },

    /**
     * stopProp - Do nothing, just to stop event propogation
     */
    stopProp() { }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    PreIngestService.$on("event:preIngestProcessingRecordSerach", (searchParams) => {
      this.searchObject = searchParams
      this.searchProcessingRecords()
    })
    PreIngestService.$on("event:refreshSearchResult", (reason) => {
      this.searchProcessingRecords(reason)
    })
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    PreIngestService.$off("event:preIngestProcessingRecordSerach")
    PreIngestService.$off("event:refreshSearchResult")
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/PreIngest/ProcessingRecords/ProcessingRecordsSearchResult.vue